
    export default {
        props: ['title'],
    }
